import type { AxiosInstance } from 'axios';
import { GetCityListInputType, GetTicketsInputType } from '../types/facades/ITicketPickerFacade';
import type { City } from '../types/models/City';
import { FareProfile } from '../types/models/FareProfile';
import { Tickets } from '../types/models/Tickets';
import { TransportMode } from '../types/models/TransportMode';
import type { ITransportTicketPickerClient } from '../types/services/ITransportTicketPickerClient';
import { CardSupport } from '../types/models/CardSupport';

export class TransportTicketPickerClient implements ITransportTicketPickerClient {
    private _httpClient;

    private readonly _apiNamespace = '/transportTicketPicker';

    constructor(httpClient: AxiosInstance) {
        this._httpClient = httpClient;
    }

    public async getCardSupportList(): Promise<CardSupport[]> {
        const response = await this._httpClient.get<Array<CardSupport>>(`${this._apiNamespace}/getCardSupportList`);
        return response.data;
    }

    public async getFareProfileList(): Promise<FareProfile[]> {
        const response = await this._httpClient.get<Array<FareProfile>>(`${this._apiNamespace}/getFareProfileList`);
        return response.data;
    }

    public async getCityList(params: GetCityListInputType): Promise<Array<City>> {
        //try {
        const response = await this._httpClient.get<Array<City>>(`${this._apiNamespace}/getCityList`, { params });

        return response.data;
        /*  } catch (error) {
            console.log(error)
        } */
    }

    public async getTransportModeList(): Promise<Array<TransportMode>> {
        const response = await this._httpClient.get<Array<TransportMode>>(`${this._apiNamespace}/getCityList`);

        return response.data;
    }

    public async getTickets(params: GetTicketsInputType): Promise<Tickets> {
        const response = await this._httpClient.get<Tickets>(`${this._apiNamespace}/getMatchingTicket`, {
            params,
        });

        return response.data;
    }
}
